import React from 'react';

import Button from '../button/Button';
import Modal from './Modal';

const BudgetFailureModal = ({ handleClose }) => (
  <Modal handleClose={() => handleClose()}>
    <i className="c-modal__budget-icon far fa-chart-bar" />

    <h2 className="c-modal__title">Budget Not Balanced</h2>
    <p>
      You must achieve a savings target of £28m before you can submit your budget.
      Please try again.
    </p>

    <Button onClick={() => handleClose()}>Try Again</Button>
  </Modal>
);

export default BudgetFailureModal;



// WEBPACK FOOTER //
// ./src/components/common/modal/BudgetFailureModal.jsx